import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';

export const ConsentWrapper = styled.div`
  margin-top: ${spacing.space40};
  flex-direction: column;
`;

export const ConsentTextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: ${spacing.space4};

  > span {
    > div {
      display: inline-flex;
      vertical-align: bottom;
      margin-left: ${spacing.space8};
    }
  }
`;

export const ReadMoreButtonDesktopWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 20%;
  justify-content: flex-end;
  align-self: flex-start;

  @media (max-width: ${breakpoints.m}) {
    display: none;
  }
`;

export const ReadMoreButtonMobileWrapper = styled.div`
  display: none;
  align-items: center;
  align-self: flex-start;
  margin-top: ${spacing.space4};
  margin-bottom: ${spacing.space4};

  @media (max-width: ${breakpoints.m}) {
    display: flex;
  }
`;

export const AdditionalStatementWrapper = styled.div`
  margin-top: ${spacing.space40};
  margin-bottom: ${spacing.space40};
`;

export const SelectAllToggleWrapper = styled.div`
  margin-top: ${spacing.space40};
`;

export const UserInteractionWrapper = styled.div`
  margin-top: ${spacing.space40};
`;
